import {
  TYPES,
  setBookInfo,
  setBookWithMeta,
  setBookMarks,
  setFavorite,
  setHighLights,
  deleteHighlight,
  addHighlight,
  deleteBookmark,
  addBookmark,
  setAppearenceTextSize,
  setAppearenceTextColor,
  setAppearenceTextFlow,
  setAppearenceTextFont,
  onUpdateNote,
  setUrlParams,
  setBookUrl,
  setBookId,
  getBookInfo,
  getNotes,
  getAppearence
} from "../actions/reader"
import { setLanguage } from '../actions/user'
import { SERVER } from '../constants'
import {
  getUser, updateUser, getStoreAppearence, storeSize,
  storeColor, storeFlow, storeFont
} from "../utilities/utilities";
import { put, takeEvery, all, call } from 'redux-saga/effects'
import * as API from '../API/reader'

function* onSetBaseParams ({payload: {params, path}}) {
  if (path.length === 0) {
    let u = getUser()
    path = u.path ? u.path : path
  }
  params.path = path
  updateUser(params)

  let userData = getUser()
  yield put(setLanguage(userData.language))

  yield put(setUrlParams(userData))

  let id = userData.path
  if (!id) return

  yield put(setBookUrl(SERVER + '/api/v1.0/files?fast_hash=' + path + '&access_token=' + userData.access_token))
  yield put(setBookId(id))
  yield put(getAppearence())

  yield put(getBookInfo(id))
}

function* onGetBookInfo ({payload}, limit = 0) {
  try {
    let bookInfo = yield call(() => API.getBookInfo(payload))
    let book = yield call(() => API.getBookWithMeta(payload))

    if (bookInfo.status === 'ready' && book.path) {
      yield put(getNotes(payload))
      yield put(setBookWithMeta(book))
      yield put(setBookInfo(bookInfo))
    } else if (bookInfo.status === 'failed') {
      yield put(setBookInfo(bookInfo))
    }
  } catch (error) {
    console.log('Error to get book info. ' + error)
  }
}

function* onGetBookWithMeta ({payload}) {
  try {
    let book = yield call(() => API.getBookWithMeta(payload))
    yield put(setBookWithMeta(book))
  } catch (error) {
    console.log('Error to get book with meta. ' + error)
  }
}

function* onGetNotes ({payload}) {
  try {
    let notes = yield call(() => API.getNotes(payload))

    let bookmarks = notes.filter((note) => {return note.type === 'bookmark' || note.type.value === 'bookmark'})
    let highlights = notes.filter((note) => {return note.type === 'highlight' ||
      note.type.value === 'highlight' ||
      note.type === 'note' ||
      note.type.value === 'note' })

    bookmarks = yield all(bookmarks.map(note => call(() => API.getNote(note.uuid, payload))))
    highlights = yield all(highlights.map(note => call(() => API.getNote(note.uuid, payload))))

    yield put(setBookMarks(bookmarks))
    yield put(setHighLights(highlights))
  } catch (error) {
    console.log('Error to get notes. ' + error)
  }
}

function* updateReadPosition ({payload}) {
  try {
    yield call(() => API.updateReadPosition(payload))
  } catch (error) {
    console.log('Error to update read position. ' + error)
  }
}

function* updateFavorite ({payload}) {
  try {
    yield call(() => API.updateFavorite(payload))
    yield put(setFavorite(payload))
  } catch (error) {
    console.log('Error updating favorite', error)
  }
}

function* deleteNote ({ payload }) {
  try {
    yield call(() => API.deleteNote(payload))
    if ( payload.isHighlight ) {
      yield put(deleteHighlight(payload))
    } else {
      yield put(deleteBookmark(payload))
    }
  } catch (error) {
    console.log('Error to delete note', error)
  }
}

function* updateNote ({ payload }) {
  try {
    yield call(() => API.updateNote(payload))
    yield put(onUpdateNote(payload))
  } catch(error) {
    console.log('Error to update note', error)
  }
}

function* addNote ({ payload }) {
  try {
    let createdNote = yield call(() => API.addNote(payload))
    let note = yield call(() => API.getNote(createdNote.uuid, payload.path))
    if ( payload.isHighlight ) {
      yield put(addHighlight(note))
    } else {
      yield put(addBookmark(note))
    }
  } catch (error) {
    console.log('Error to add note', error)
  }
}

function* onGetAppearence () {
  const appearence = getStoreAppearence()

  yield put(setAppearenceTextColor(appearence.color))
  yield put(setAppearenceTextSize(appearence.size))
  yield put(setAppearenceTextFont(appearence.font))
  yield put(setAppearenceTextFlow(appearence.flow))
}

function* setTextSize ({payload}) {
  storeSize(payload)
  yield put(setAppearenceTextSize(payload))
}

function* setTextColor ({payload}) {
  storeColor(payload)
  yield put(setAppearenceTextColor(payload))
}

function* setTextFont ({payload}) {
  storeFont(payload)
  yield put(setAppearenceTextFont(payload))
}

function* setTextFlow ({payload}) {
  storeFlow(payload)
  yield put(setAppearenceTextFlow(payload))
}

export const readerSaga = [
  takeEvery(TYPES.ON_SET_BASE_PARAMS, onSetBaseParams),
  takeEvery(TYPES.GET_BOOK_INFO, onGetBookInfo),
  takeEvery(TYPES.GET_BOOK_WITH_META, onGetBookWithMeta),
  takeEvery(TYPES.GET_NOTES, onGetNotes),
  takeEvery(TYPES.UPDATE_READ_POSITION, updateReadPosition),
  takeEvery(TYPES.UPDATE_FAVORITE, updateFavorite),
  takeEvery(TYPES.DELETE_NOTE, deleteNote),
  takeEvery(TYPES.ADD_NOTE, addNote),
  takeEvery(TYPES.GET_APPEARENCE, onGetAppearence),
  takeEvery(TYPES.APPEARENCE_TEXT_SIZE, setTextSize),
  takeEvery(TYPES.APPEARENCE_TEXT_COLOR, setTextColor),
  takeEvery(TYPES.APPEARENCE_TEXT_FONT, setTextFont),
  takeEvery(TYPES.APPEARENCE_TEXT_FLOW, setTextFlow),
  takeEvery(TYPES.UPDATE_NOTE, updateNote)
]


// WEBPACK FOOTER //
// ./src/sagas/reader.js